import { ColumnDef } from "@tanstack/react-table";

import { TODO } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { format } from "date-fns";
import { datesMatch } from "@/utils";
import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<TODO>[] {
  return [
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => (
        <div className="w-[180px] flex flex-col">
          <span>{row.index + 1}</span>
          <span className="text-xs">
            (Created at - {format(row.getValue("createdAt"), "PPP")} )
          </span>
        </div>
      ),
      enableSorting: false,
      enableHiding: false,

      filterFn: (row, id, value) => {
        return datesMatch(row.getValue(id), value);
      },
    },
    {
      accessorKey: "title",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Title" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("title")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      accessorKey: "description",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Description" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("description")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      id: "actions",
      cell: ({ row }) => <DataTableRowActions row={row} />,
    },
  ];
}
